import { render, staticRenderFns } from "./XTable.vue?vue&type=template&id=86243502&scoped=true&"
import script from "./XTable.vue?vue&type=script&lang=js&"
export * from "./XTable.vue?vue&type=script&lang=js&"
import style0 from "./XTable.vue?vue&type=style&index=0&id=86243502&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86243502",
  null
  
)

export default component.exports